<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { EconomicSubjectVatType } from "@core/schema/EconomicSubjectVatType.js";
	import { SubscriptionFrequency } from "@core/schema/SubscriptionFrequency.js";
	import { SubscriptionKind } from "@core/schema/SubscriptionKind.js";
	import { SubscriptionSelection } from "@core/schema/SubscriptionSelection.js";
	import { SubscriptionSize } from "@core/schema/SubscriptionSize.js";
	import { SubscriptionVariant } from "@core/schema/SubscriptionVariant.js";
	import { calculateSubscriptionSavings } from "@core/schema/utils/calculateSubscriptionSavings.js";
	import { formatPercentage } from "@core/utils/formatPercentage.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { defaultDestinationCountry } from "../../defaultDestinationCountry.js";
	import { selectedCurrency } from "../../state/selectedCurrency.svelte.js";
	import translations from "./FathersClubSavingsStats.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
	const { tenant, subcategories, mothersBlendProduct, cafeinaProduct, exchangeRatesSetting } = getGlobalTemplateProps();
	const { MOTHERS_BLEND_CONSTANT_PRICE_ENABLED } = getGlobalSettings();

	const currency = $derived(selectedCurrency.current ?? tenant.defaultCurrency);

	const savings = $derived.by(() => {
		if (!Cart.loaded) {
			return {
				percentage: "",
				withTax: "",
				freeDelivery: "",
			};
		}
		const destinationCountry = Cart.destinationCountry ?? defaultDestinationCountry;
		const vatType = Cart.vatType ?? EconomicSubjectVatType.NotVatSubject;

		const { withTax, percentage } = calculateSubscriptionSavings(
			subcategories,
			destinationCountry,
			{
				selection: SubscriptionSelection.MothersBlend,
				frequency: SubscriptionFrequency.Weeks4,
				size: SubscriptionSize.G250x2,
				variant: SubscriptionVariant.Espresso,
				kind: SubscriptionKind.Recurring,
				startsAt: "",
			},
			mothersBlendProduct,
			cafeinaProduct,
			currency,
			vatType,
			exchangeRatesSetting?.exchangeRates ?? [],
			MOTHERS_BLEND_CONSTANT_PRICE_ENABLED,
		);

		return {
			percentage: formatPercentage(percentage, tenant.locale, false),
			withTax: formatPrice(withTax, currency, tenant.locale, false),
			freeDelivery: formatPrice(0, currency, tenant.locale, false),
		};
	});
</script>

<div class="flex flex-col items-stretch gap-3 flex-1 font-bold sm:text-5/tighter uppercase">
	<div
		class="h-16 sm:h-20 flex flex-col font-antipol items-center justify-center gap-0.5 px-8 bg-white text-fcrdarkgray"
	>
		<Formatted text="{savings.percentage} {translate('savingsPercentageLabel')}" />
	</div>
	<div
		class="h-16 sm:h-20 flex flex-col font-antipol items-center justify-center gap-0.5 px-8 bg-fcrsalmon text-fcrdarkgray"
	>
		<Formatted text="{savings.withTax} {translate('yearlySavingsLabel')}" />
	</div>
	<div class="h-16 sm:h-20 flex flex-col font-antipol items-center justify-center gap-0.5 px-8 bg-fcrslate text-white">
		<Formatted text="{savings.freeDelivery} {translate('freeDeliveryLabel')}" />
	</div>
</div>
